import { render } from "./ClientLastContact.vue?vue&type=template&id=9c97b644&scoped=true"
import script from "./ClientLastContact.vue?vue&type=script&lang=js"
export * from "./ClientLastContact.vue?vue&type=script&lang=js"

import "./ClientLastContact.vue?vue&type=style&index=0&id=9c97b644&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c97b644"]])

export default __exports__